'use strict';

import template from './comingSoonVideosDir.html';

export const CSVDirName = 'comingSoonVideos';
export function CSVDir(){
  return {
    restrict: 'E', 
    template: template,
    scope: {
      videos: '=',
      rowcount: '='
    },
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/comingSoonVidoes/comingSoonVideosDir.js